import type { components } from '@front/generated/apiClient';
import { DomainV2 } from 'troppus-common/domain';

import FeatureFlag = DomainV2.FeatureFlag;

type Api = components['schemas']['FeatureFlag'];

export const fromApi = (api: Api): FeatureFlag => {
  return FeatureFlag.Construct({
    projectId: api.projectId,
    flags: api.flags,
    createdAt: api.createdAt,
    updatedAt: api.updatedAt,
    updatedBy: api.updatedBy,
  });
};
